import { render, staticRenderFns } from "./AbsenceModal.vue?vue&type=template&id=594e4d60"
import script from "./AbsenceModal.vue?vue&type=script&lang=js"
export * from "./AbsenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports